import { i as d, x as c, s as l } from "../../lit-element-6iugfgmM.js";
import { e as p } from "../../custom-element-wk-AooBb.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import "../../sp-button-fa52iiKJ.js";
import "../../sp-card-VHI50CUC.js";
import { Localize as h } from "../../lib/I18N.js";
import { s as m } from "../../SpCard-ArxIdQtE.js";
const v = { "fontpack-card.action.view-font-pack": "View Pack" }, f = d`:host{--card-sample-chooser-height: 20px;display:inline-block;container:card / inline-size}sp-card{height:100%;width:100%}#content{color:var(--spectrum-gray-700);font-size:14px;font-weight:400}#description{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:200px}@container card (inline-size){#description{width:80cqi}}#footer{align-items:center;display:flex;justify-content:flex-end;padding-top:20px}#thumbnail-container{position:relative}#thumbnail-image-slot::slotted(img){height:calc(100% - var(--card-sample-chooser-height));width:100%}#sample-chooser-placeholder{height:var(--card-sample-chooser-height);margin:0;padding:0}sp-button{background:var(--spectrum-gray-200);color:var(--spectrum-gray-900);float:right}`;
var g = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
let n = class extends h(l, v) {
  static get styles() {
    return [m, f];
  }
  render() {
    return c`<sp-card><div id="thumbnail-container" slot="preview"><slot id="thumbnail-image-slot" name="thumbnail"></slot><div id="sample-chooser-placeholder"></div></div><div slot="heading"><slot name="fontpack-title"></slot></div><div id="content" slot="subheading" part="content"><div id="description"><slot name="description"></slot></div><div id="font-count"><slot name="font-count"></slot></div></div><div id="footer" slot="footer"><sp-button tabindex="-1" aria-hidden="true">${this.t("fontpack-card.action.view-font-pack")}</sp-button></div></sp-card>`;
  }
};
n = ((s, i, o, e) => {
  for (var r, t = e > 1 ? void 0 : e ? u(i, o) : i, a = s.length - 1; a >= 0; a--) (r = s[a]) && (t = (e ? r(i, o, t) : r(t)) || t);
  return e && t && g(i, o, t), t;
})([p("af-fontpack-card")], n);
const O = n;
export {
  O as default
};
//# sourceMappingURL=FontpackCard.js.map
